import ApiClient from '../client';
import Config from '../../services/config.service';
const config = new Config();
const path = require('path');

class DashboardAPI extends ApiClient {

  constructor() {
    super();
  }

  async getTaskQueue(page = 1, requestObject, controller) {
    const route = path.join(
      this.DASHBOARD_API_PATH,
      `/task-queue-track/?page_size=${config.itemsPerPage.tasks}&page=${page}${requestObject ? `&object=${requestObject}` : ''}`
    );
    const response = await this.get(route, {
      ...controller && { signal: controller.signal },
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderTaskQueue(direction, field, page = 1, requestObject, controller) {
    const route = path.join(
      this.DASHBOARD_API_PATH,
      `task-queue-track/?page_size=${config.itemsPerPage.tasks}&page=${page}&ordering=${direction}${field}${requestObject ? `&object=${requestObject}` : ''}`
    );
    const response = await this.get(route, {
      ...controller && { signal: controller.signal },
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getTask(id) {
    const route =path.join(
      this.DASHBOARD_API_PATH,
      `task-queue-track/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDatasetLastTasks(requestObject, pageSize = 3) {
    const route = path.join(
      this.DASHBOARD_API_PATH,
      `task-queue-track/?object=${requestObject}&page_size=${pageSize}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data.results;
    }
    return false;
  }

  async getIndexerLogs(indexerId, pageSize = 5) {
    const route = path.join(
      this.DASHBOARD_API_PATH,
      `task-queue-track/?object_class=remoteapiindex&object_id=${indexerId}&page_size=${pageSize}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

}

const dashboardAPI = new DashboardAPI();
export default dashboardAPI;
